// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tfbTP","question":"styles_question__2-Bad","inputVisibleButton":"styles_inputVisibleButton__30IWr","note":"styles_note__m5s5d"};